export const preview = {
  width: 345,
  height: 345,
  gap: 5,
  topPadding: 16,
  heightForNucleotide: 105,
  widthForBond: 358,
  heightForBond: 268,
} as const;
